import React, { useState, useEffect } from "react";
import Select from "react-select"
import { navigate } from "gatsby";
import $ from 'jquery'

function SearchResultsPagination(props) {
    const [pagenumber, setPageNumber] = useState(props.current_page_number);
    const page_options = [] 
    let i = 1;
    while (i <= props.number_of_pages) {
        page_options.push({ value: i, label: i, })
        i++;
    }
    const pageChange = event => {
        setPageNumber((event.value))
        let pageUrl = 'page-' + ((event.value)) + '/';
        //get current url
        const urlwithoutsort = (props?.location_path).split("page-");
        // concat url and navigate  
        if(event.value == 1) {
            navigate(urlwithoutsort[0])
        }else {
            navigate(urlwithoutsort[0] + pageUrl)
        }
        var target = $("body");
        $('html,body').animate({
            scrollTop: target.offset().top - 250
        },100);
    } 
    return (

        <div className="al-pagination">
            Page 
            <Select
                options={page_options}
                placeholder={(props.current_page_number)}
                classNamePrefix={"select-opt"}
                isSearchable={false}
                onChange={pageChange}
                styles={customStyles}  
                value={page_options.find(
                  obj => obj.value === (props.current_page_number)
                )}
                // defaultValue={"1"}
            />
            of {props.number_of_pages}
        </div>
    );
}


const customStyles = {
    option: (styles, { data, isDisabled, isFocused, isSelected }) => {
      return {
        ...styles,
        backgroundColor: isFocused ? "#005480" : null,
        color: isFocused ? "#ffffff" : "#4c505b",
      }
    },
    control: styles => ({
      ...styles,
      backgroundColor: null, 
      width:"70px",
      borderRadius: "6px",
      paddingLeft: "8px",
      height: "48px",
    //   boxShadow: "none",
      color: "#4c505b",
      fontSize: "16px",
      fontWeight: "400",
    }),
    valueContainer: styles => ({
      ...styles,
      fontSize: ".875rem",
      paddingLeft: 0,
      paddingRight: 0,
      lineHeight: "30px",
      fontWeight: "300",
      cursor: "pointer",
    }),
    dropdownIndicator: styles => ({
      ...styles,
      paddingLeft: 0,
      //  color: "#ffffff",
    }),
    indicatorsContainer: styles => ({
      ...styles,
      // color: '#ffffff',
      padding: 0,
      cursor: "pointer",
    }),
    indicatorSeparator: () => null,
    placeholder: defaultStyles => {
      return {
        ...defaultStyles,
        color: "#4c505b",
        marginLeft: 0,
      }
    },
  }

export default SearchResultsPagination